export default __webpack_public_path__ + "static/media/header-cancel.5c4f4436.svg";